import Vue from 'vue'
import Router from 'vue-router'
import authApi from '@api/auth' //eslint-disable-line
import { store } from '@store' //eslint-disable-line
import { initRouter } from '@technologyadvice/relay-frontend/src/util/router'
import { intersection } from 'lodash'
import routes from './routes'

Vue.use(Router)

const portal = 'clicks';

const router = new Router({
    mode: 'history',
    base: `/${portal}/`,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
})

export function checkPermissions(to, next) {
    const nearestWithScopes = to.matched
        .slice()
        .reverse()
        .find(route => route.meta && route.meta.scopes)
    if (nearestWithScopes) {
        const hasScopes = intersection(nearestWithScopes.meta.scopes, store.state.auth.user.scopes).length > 0
        if (!hasScopes) next('/404')
    }
}

export default initRouter({
    Vue, authApi, store, router, portal,
})
